import noop from 'lodash.noop';

import { createLegacyHistory } from './utils/create-legacy-history';
import { BrowserHistory } from './types';

export const DEFAULT_LOCATION = { pathname: '', search: '', hash: '' };

export const DEFAULT_MATCH = {
	params: {},
	isExact: false,
	path: '',
	url: '',
	query: {},
};

export const DEFAULT_ROUTE = {
	path: '',
	component: () => null,
	name: '',
};

export const DEFAULT_HISTORY: BrowserHistory = createLegacyHistory();

export const DEFAULT_ACTION = 'POP';
